import "./BlockResultLink.css";

function BlockResultLink(props: {
  type: string;
  header?: string;
  calories: number;
  onClick: () => void;
}) {
  return (
    <div className="block-result-link df fdc aic jcsa" onClick={props.onClick}>
      {props.header && <div className="result-link-header">{props.header}</div>}
      <div className="result-link-body">{props.calories}</div>
    </div>
  );
}

export default BlockResultLink;
